import classNames from '@/helpers/classNames';
import { IInputSelect, IInputSelectOption } from '@/types/IInput';

export default function InputSelect({
  id,
  label,
  options,
  value,
  message,
  onChange,
  selectClassName = 'block w-full py-2 font-medium text-gray-900 focus:ring-brand-500 focus:border-brand-500 shadow-sm border-gray-300 rounded-md',
}: IInputSelect): JSX.Element {
  return (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700">
        {label}
      </label>
      <div className={label ? 'mt-1' : ''}>
        <select
          id={id}
          name={id}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          className={classNames(
            selectClassName,
            label ? 'text-base leading-6' : 'text-sm leading-5',
          )}
        >
          {options.map((option: IInputSelectOption) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>
      </div>
      {message && (
        <p className="mt-2 text-sm leading-5 text-gray-500">{message}</p>
      )}
    </div>
  );
}
